import React from "react";
import { Card, FormGroup, Label, Input, Row, Col } from "reactstrap";

const PaymentMethod = ({
  paymentMethod,
  handlePaymentSelection,
  darkMode,
  color,
  currency,
  tipAmountValue,
  restaurantsDetail,
  matchedItem,
}) => {
  return (
    <Row className="d-flex flex-column pt-3 overflow-y-auto">
      <Col className="my-4 pb-3 d-flex flex-column align-items-md-center justify-content-start">
        {(matchedItem[0]?.orderType === "dinein" ||
          matchedItem[0]?.orderType === "takeaway") && (
          <Card
            className={
              darkMode
                ? "p-3 mb-3 cart__payment_card-dark"
                : "p-3 mb-3 cart__payment_card"
            }
            style={{ width: "90%", maxWidth: "500px" }}
          >
            <FormGroup check>
              <Label check className="fs--18 fw--600">
                <Input
                  type="radio"
                  name="pay"
                  checked={paymentMethod === "cash"}
                  value={paymentMethod}
                  onChange={() => handlePaymentSelection("cash")}
                  style={{ "--accent-color": `${color}` }}
                />{" "}
                Pay With Cash
              </Label>
            </FormGroup>

            {paymentMethod === "cash" && tipAmountValue > 0 && (
              <div
                className="mt-3 px-3 py-2 rounded"
                style={{
                  backgroundColor: darkMode ? "#2c2c2c" : "#f7f7f7",
                  borderLeft: `5px solid ${color}`,
                }}
              >
                <p
                  className="mb-0 fs--14 fw--500"
                  style={{ color: darkMode ? "#fff" : "#333" }}
                >
                  💡 Tip Amount :
                  <span style={{ color, fontWeight: 600 }}>
                    {" "}
                    {currency}
                    {""}
                    {tipAmountValue}
                  </span>
                </p>
              </div>
            )}
          </Card>
        )}

        {restaurantsDetail?.paymentConnections?.stripe ||
        restaurantsDetail?.paymentConnections?.paypal ? (
          <Card
            className={
              darkMode
                ? "px-3 mb-3 cart__payment_card-payment-dark"
                : "px-3 mb-3 cart__payment_card-payment"
            }
            style={{ width: "90%", maxWidth: "500px" }}
          >
            <FormGroup check>
              <Label check className="fs--18 fw--600">
                <Input
                  type="radio"
                  name="pay"
                  value={paymentMethod}
                  checked={
                    paymentMethod === "Paypal" || paymentMethod === "Stripe"
                  }
                  onChange={() => {
                    handlePaymentSelection(
                      restaurantsDetail?.paymentConnections?.stripe
                        ? "Stripe"
                        : "Paypal"
                    );
                  }}
                  style={{ "--accent-color": `${color}` }}
                />{" "}
                Pay With Card
              </Label>
            </FormGroup>
          </Card>
        ) : (
          <p className="text-center py-5">Payment Detail Is not Added</p>
        )}
      </Col>
    </Row>
  );
};

export default PaymentMethod;
